import ParagraphBlock from './paragraphBlock';

export default ParagraphBlock;
